(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon/assets/javascripts/video-analysis-controller.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon/assets/javascripts/video-analysis-controller.js');
"use strict";


const {
  useCallback
} = React;
const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  selectCurrentVideo,
  selectMatchVideo,
  selectPlaybackState
} = svs.components.tipsen.store.reducers.videoAnalysesSlice.selectors;
const {
  setCurrentVideo
} = svs.components.tipsen.store.reducers.videoAnalysesSlice.actions;
const {
  VideoAnalysisButtonCircle
} = svs.components.tipsen.videoAnalysisButton;
const {
  useMediaQuery
} = svs.components.lbUtils.useMediaQuery;
const {
  STATISTIC_SIDEBAR_QUERY
} = svs.components.tipsen.constants;
const VideoAnalysisController = _ref => {
  let {
    eventNumber
  } = _ref;
  const dispatch = useDispatch();
  const isSidebarWidth = useMediaQuery(STATISTIC_SIDEBAR_QUERY);
  const matchVideo = useSelector(state => selectMatchVideo(state, eventNumber));
  const currentVideo = useSelector(selectCurrentVideo);
  const playbackState = useSelector(selectPlaybackState);
  const isCurrentlySet = currentVideo && matchVideo && currentVideo.id === matchVideo.id;
  const isPending = isCurrentlySet && !playbackState.isReady;
  const isPlaying = isCurrentlySet && playbackState.isPlaying;
  const isPaused = isCurrentlySet && playbackState.isReady && !playbackState.isPlaying;
  const handlePlayToggle = useCallback(e => {
    if (!isSidebarWidth) {
      e.preventDefault();
    }
    if (isPending) {
      return;
    }
    dispatch(setCurrentVideo(isCurrentlySet ? null : matchVideo));
  }, [isSidebarWidth, isPending, dispatch, isCurrentlySet, matchVideo]);
  const progress = playbackState.progress || 0;
  const isDisabled = !matchVideo;
  const ariaLabel = "".concat(isPlaying || isPaused ? 'Stäng' : 'Öppna', " videoanalys f\xF6r match ").concat(eventNumber);
  const title = "".concat(isPlaying || isPaused ? 'Stäng' : 'Öppna', " videoanalys f\xF6r match ").concat(eventNumber);
  return React.createElement("div", {
    className: "pg_coupon_row__video_analysis_controller"
  }, React.createElement(VideoAnalysisButtonCircle, {
    ariaLabel: ariaLabel,
    disabled: isDisabled,
    isPaused: isPaused,
    isPending: isPending,
    isPlaying: isPlaying,
    onClick: handlePlayToggle,
    progress: isCurrentlySet && typeof progress === 'number' ? progress : 0,
    title: isDisabled ? "Videoanalys f\xF6r match ".concat(eventNumber, " \xE4r inte tillg\xE4nglig") : title
  }));
};
setGlobal('svs.components.tipsen.coupon.VideoAnalysisController', VideoAnalysisController);

 })(window);